<template>
    <div>
        <template v-if="(detailedItem.interface_version == 2 && detailedItem.order.reference_order_type_id == 1) || beforeStartSave">
            <div
                v-if="!isChangeManager"
                class="d-flex justify-content-between flex-wrap mb-2 pt-2 pb-2"
            >
                <div>
                    <h5>Заказ #{{ detailedItem.order_id }} . {{ detailedItem.service_name }}</h5>
                </div>
                <span class="text-bold-size-13 text-secondary">
                    <i class="fas fa-user-circle text-orange mr-1"></i> Менеджер:
                    <span class="font-weight-light">{{ getAllManagerNames() }}</span>
                    <button
                        class="active-panel-block_one-check-button"
                        @click="isChangeManager = true"
                        v-if="!isAgent"
                    >
                        <b-icon icon="pencil-fill" scale="1.2"></b-icon>
                    </button>
                </span>
                <!-- <div class="d-flex align-items-center" v-if="detailedItem.reference_property_type_id"></div> -->
            </div>

            <div
                v-if="isChangeManager"
                class="active-panel-block-change-manager mb-1"
            >
                <div class="active-panel-block-select-user-wrapper">
                    <tsoft-select-user
						key="select-manager_1"
                        id="select-manager_1"
                        :roles="`logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||bsz-manager`"
                        :needNullElement="true"
						:needMultipleSelect="true"
						:needOnlyOneFromDepartment="true"
                        :selectedArray="getSelectedUserIds()"
                        @set="setUserIds"
                    ></tsoft-select-user>
                </div>
                <div>
                    <button
                        class="btn btn-outline-red mr-3"
                        @click="cancelChangeManager"
                    >Отмена</button>

                    <button
                        class="btn btn-outline-green"
                        @click="saveChangeManager"
                    >Сохранить</button>
                </div>
            </div>
            <b-card no-body class="bdr-tabs">
                <b-tabs 
                    card 
                    style="flex-direction: column;"
                >
                  <b-tab :title="`Форма котировки поставки${deliveryQuotationDate}`" active>
                    <b-card-text v-if="detailedItem.order">
                        <OrderServiceDeliveryQuotation 
                            :order_id="detailedItem.order_id"
                            :order_service_id="detailedItem.id"
                            :order_reference_status_id="detailedItem.order.reference_status_id"
                            :order_reference_order_type_id="detailedItem.order.reference_order_type_id"
                            @setValuesFromQuotation="setValuesFromQuotation"
                            @isRequestFormValid="isRequestFormValid"
                            @saved="onSaved"
                            @changeOrderToQuotationSent="onChangeOrderToQuotationSent"
                            @makeOrderSupply="onMakeOrderSupply"
                            @orderUpdated="handleOrderUpdated"
                         />
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Ведение поставки">
                    <b-card-text>
                        
                        <b-jumbotron 
                            header="Тип перевозки" 
                            header-level="5"
                            lead="От выбранного варианта зависит набор полей и свойств. Ведение услуги будет доступно после перевода Заявки в Поставку."
                        >
                            <div style="max-width: 400px">
                                <tsoft-select-of-properties
                                    :key="`reference_property_type_id_${detailedItem.reference_property_type_id}`"
                                    :reference_id="62"
                                    :needGroups="false"
                                    :needNullElement="true"
                                    :needMultipleSelect="false"
                                    :selected="detailedItem.reference_property_type_id"
                                    @set="setOrderServiceType"
                                ></tsoft-select-of-properties>  
                                <button 
                                    @click="saveOrderService()" 
                                    type="button" 
                                    class="btn btn-success btn36 mt-4"
                                    :disabled="!detailedItem.reference_property_type_id || isSavingOrderService"
                                >
                                    <span v-if="isSavingOrderService">
                                        <b-spinner small class="mr-2"></b-spinner>Сохранение...
                                    </span>                                                                        
                                    <span v-else><i class="fas fa-save mr-2"></i>Сохранить тип перевозки</span>
                                </button>
                            </div>
                            <div class="small text-muted mt-4 font-italic">
                                Обращаем ваше внимание, что после перевода в поставку изменить тип транспорта будет невозможно.<br />
                                Выбирайте тип транспорта после утверждения котировки с клиентом!
                            </div>
                        </b-jumbotron>
                    </b-card-text>
                  </b-tab>
                </b-tabs>
            </b-card>            
        </template>
        <template v-else>
            <div>
                <div class="d-flex justify-content-between flex-wrap mb-3">
                    <div>
                        <h5>Заказ #{{ detailedItem.order_id }}. {{ detailedItem.service_name }}{{ nameOfType() }}</h5>
                    </div>
                    <div class="d-flex align-items-center" v-if="!isAgent">
                        <div>
                            <button v-if="chooseActiveButton(303)" @click="changeStatus(304)" type="button" class="btn btn-outline-green mr-3">Взять в работу</button>
                            <button v-if="chooseActiveButton(304)" @click="changeStatus(305)" type="button" class="btn btn-outline-red mr-3">Приостановить</button>
                            <button v-if="chooseActiveButton(305)" @click="changeStatus(304)" type="button" class="btn btn-outline-primary mr-3">Вернуть в работу</button>
                            <button v-if="chooseActiveButton(304)" @click="changeStatus(306)" type="button" class="btn btn-outline-green mr-3">Завершить</button>
                            <button v-if="chooseActiveButton(306)" @click="changeStatus(307)" type="button" class="btn btn-outline-green mr-3">Закрыть</button>
                        </div>
                    </div>
                </div>

                <div
                    v-if="!dataOverlay && !isChangeManager"
                    class="row active-panel-block align-items-center m-0"
                >
                    <div class="active-panel-block_icon">
                        <b-icon icon="grip-vertical" font-scale="2" class="text-secondary"></b-icon>
                    </div>
                    <div class="active-panel-block_one">
                        <span class="text-bold-size-13 text-secondary">
                            <i class="fas fa-user-circle text-orange mr-1"></i> Менеджер:
                            <span class="font-weight-light mr-2">{{ getAllManagerNames() }}</span>
                            <button
                                v-if="!isAgent"
                                class="active-panel-block_one-check-button"
                                @click="isChangeManager = true"
                            >
                                <b-icon icon="pencil-fill" scale="1.2"></b-icon>
                            </button>
                        </span>
                    </div>
                    <div class="active-panel-block_two text-bold-size-13">
                        <span class="text-secondary mr-3 cursor-pointer" v-if="!editMode && !isAgent" @click="editMode = true">Редактировать</span>
                        <span class="text-success mr-3 cursor-pointer" v-if="editMode" @click="save()">Сохранить</span>
                        <span class="text-secondary mr-3 cursor-pointer" v-if="editMode" @click="editMode = false">Отменить</span>
                        <span class="text-success mr-3 cursor-pointer" v-if="editMode" @click="dataExchange()" title="Заполнить данными из Котировки">
                            <b-icon icon="arrow-left-right" scale="1.2"></b-icon>
                        </span>
                        <span class="font-weight-bold text-uppercase text-secondary"><i class="fas fa-info-circle text-orange mr-1"></i> Статус:</span>
                        <span class="font-weight-light text-uppercase mr-2">{{ getStatusName() }}</span>
                    </div>
                </div>

                <div
                    v-if="isChangeManager"
                    class="active-panel-block-change-manager"
                >
                    <div class="active-panel-block-select-user-wrapper">
                        <tsoft-select-user
							key="select-manager_2"
                            id="select-manager_2"
                            :roles="`logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||bsz-manager`"
                            :needNullElement="true"
							:needMultipleSelect="true"
							:needOnlyOneFromDepartment="true"
                            :selectedArray="getSelectedUserIds()"
                            @set="setUserIds"
                        ></tsoft-select-user>
                    </div>
                    <div>
                        <button
                            class="btn btn-outline-red mr-3"
                            @click="cancelChangeManager"
                        >Отмена</button>

                        <button
                            class="btn btn-outline-green"
                            @click="saveChangeManager"
                        >Сохранить</button>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="detailedItem.interface_version == 2 && detailedItem.reference_property_type_id && detailedItem.order.reference_order_type_id == 2 && currentOrderServiceComponent != ''">
            <div class="interface_v2 my-4">
                <component 
                    :is="currentOrderServiceComponent"
                    :detailedItem="detailedItem"
                    :editMode="editMode"
                    :saveMode="saveMode"
                    :filteredDocs="filteredDocs"
                    @updateData="updateData"
                ></component>
                <div class="my-4">
                    <OrderServiceComments :orderServiceId="detailedItem.id" />
                </div>
            </div>
        </template>
        <template v-else-if="detailedItem.interface_version != 2">
            <!-- Блок котирования для услуг (кроме логистики) -->
            <div v-if="detailedItem.reference_service_id != 23 && detailedItem.order && detailedItem.order.reference_order_type_id == 1" class="mt-4">
                <!-- Компонент котирования для общих услуг -->
                <OrderServiceGeneralQuotation
                    :order_id="detailedItem.order_id"
                    :order_service_id="detailedItem.id"
                    :order_reference_status_id="detailedItem.order.reference_status_id"
                    :order_reference_order_type_id="detailedItem.order.reference_order_type_id"
                    @orderUpdated="handleOrderUpdated"
                    @changeOrderToQuotationSent="changeOrderToQuotationSent"
                    @makeOrderSupply="onMakeOrderSupply"
                />
            </div>

            <div class="position-relative mt-3" v-if="!(isAgent && detailedItem.order && detailedItem.order.reference_order_type_id == 1)">
                <b-container fluid>
                    <span 
                        @click="detailsInfoTab = 'obshaya'"
                        :class="detailsInfoTab === 'obshaya' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
                    >Информация по услуге</span>
                    <span 
                        v-if="hasQuotationInfo && detailedItem.order && detailedItem.order.reference_order_type_id == 2"
                        @click="detailsInfoTab = 'quotation'"
                        :class="detailsInfoTab === 'quotation' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
                    >Котировка запроса</span>
                </b-container>

                <div class="interface_v2" v-show="detailsInfoTab === 'obshaya'">
                    <b-card>
                        <b-table-simple small caption-top borderless stacked class="service-properties-table">
                            <b-thead>
                                <b-tr>
                                    <b-th
                                        v-for="item in detailedItem.data"
                                        :key="item.id"
                                    >{{ item.reference_service_property_name }}</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr>
                                    <b-td
                                        :stacked-heading="item.reference_service_property_name + ':'"
                                        v-for="(item, index) in detailedItem.data"
                                        :key="item.id"
                                        :class="[item.group_id ? `grouped-prop grouped-prop-${item.reference_service_property_id}` : '', editMode ? 'edit-mode' : '']"
                                    >
                                        <template v-if="!editMode">
                                            <template v-if="item.reference == 0">
                                                <template 
                                                    v-if="
                                                        !excludePropertyFromTextFiltering(item.reference_service_property_id) && 
                                                        (item.reference_service_property_name.indexOf('Дата и время') !== -1 || 
                                                        item.reference_service_property_name.indexOf('дата и время') !== -1)
                                                    ">
                                                        {{ (item.value || 'Нет данных') | formattedDateTime }}
                                                </template>
                                                <template 
                                                    v-else-if="
                                                        !excludePropertyFromTextFiltering(item.reference_service_property_id) && 
                                                        (item.reference_service_property_name.indexOf('Срок действия') !== -1 || 
                                                        item.reference_service_property_name.indexOf('Дата') !== -1 || 
                                                        item.reference_service_property_name.indexOf('дата') !== -1)
                                                    ">
                                                        {{ (item.value || 'Нет данных') | formattedDate }}
                                                </template>
                                                <template v-else>
                                                    {{ item.value || 'Нет данных' }}
                                                </template>
                                            </template>
                                            <template v-if="item.reference != 0">
                                                {{ getPropertyNameByValue(item.value) }}
                                            </template>
                                        </template>
            
                                        <template v-if="editMode">
                                            <template v-if="item.reference == 0">
                                            <template v-if="!actionReferenceProperties[detailedItem.data[index].reference_service_property_id]">
                                                    <template v-if="item.reference_service_property_name.indexOf('Дата и время') !== -1 || item.reference_service_property_name.indexOf('дата и время') !== -1">
                                                        <b-form-input v-model="detailedItem.data[index].value" type="datetime-local" size="sm" placeholder=""></b-form-input>
                                                    </template>
                                                    <template v-else-if="item.reference_service_property_name.indexOf('Срок действия') !== -1 || item.reference_service_property_name.indexOf('Дата') !== -1 || item.reference_service_property_name.indexOf('дата') !== -1">
                                                        <b-form-input v-model="detailedItem.data[index].value" type="date" size="sm" placeholder=""></b-form-input>
                                                    </template>
                                                    <template v-else-if="item.reference_service_property_name.indexOf('Время') !== -1 || item.reference_service_property_name.indexOf('время') !== -1">
                                                        <b-form-input v-model="detailedItem.data[index].value" type="time" size="sm" placeholder=""></b-form-input>
                                                    </template>
                                                    <template v-else-if="item.reference_service_property_name.indexOf('Комментарий') !== -1 || item.reference_service_property_name.indexOf('комментарий') !== -1">
                                                        <b-form-textarea
                                                            id="textarea"
                                                            v-model="detailedItem.data[index].value"
                                                            placeholder="Введите ваш комментарий..."
                                                            rows="3"
                                                            max-rows="6"
                                                        ></b-form-textarea>
                                                    </template>
                                                    <template v-else>
                                                        <b-form-input v-model="detailedItem.data[index].value" size="sm" placeholder=""></b-form-input>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="actionReferenceProperties[detailedItem.data[index].reference_service_property_id]">
                                                        <template v-if="actionReferenceProperties[detailedItem.data[index].reference_service_property_id].type == 'number'">
                                                            <b-form-input
                                                                v-model="detailedItem.data[index].value"
                                                                size="sm"
                                                                type="number"
                                                                :readonly="actionReferenceProperties[detailedItem.data[index].reference_service_property_id].readonly"
                                                                :min="actionReferenceProperties[detailedItem.data[index].reference_service_property_id].min_value"
                                                            ></b-form-input>
                                                        </template>
                                                        <template v-if="actionReferenceProperties[detailedItem.data[index].reference_service_property_id].type == 'text'">
                                                            <b-form-input
                                                                v-model="detailedItem.data[index].value"
                                                                size="sm"
                                                                type="text"
                                                                :readonly="actionReferenceProperties[detailedItem.data[index].reference_service_property_id].readonly"
                                                            ></b-form-input>
                                                        </template>
                                                        <template v-if="actionReferenceProperties[detailedItem.data[index].reference_service_property_id].type == 'inline'">
                                                            {{ detailedItem.data[index].value }}
                                                        </template>
                                                        <template v-if="actionReferenceProperties[detailedItem.data[index].reference_service_property_id].type == 'group'">
                                                            <b-form-row>
                                                                <b-col>
                                                                    <b-form-input
                                                                        v-model="detailedItem.data[index].value"
                                                                        size="sm"
                                                                        type="text"
                                                                    ></b-form-input>
                                                                </b-col>
                                                                <b-col cols="12" md="auto">
                                                                    <template v-if="actionReferenceProperties[detailedItem.data[index].reference_service_property_id].create_doubles">
                                                                        <b-button
                                                                            size="sm"
                                                                            class="ml-2 mt3px"
                                                                            variant="success"
                                                                            title="Добавить"
                                                                            @click="addNewFieldByField(index)"
                                                                        ><b-icon icon="plus" font-scale="1.2"></b-icon></b-button>
                                                                        <b-button
                                                                            v-if="actionReferenceProperties[detailedItem.data[index].reference_service_property_id].count > 1"
                                                                            size="sm"
                                                                            class="ml-2 mt3px"
                                                                            variant="danger"
                                                                            title="Удалить"
                                                                            @click="deleteField(index)"
                                                                        ><b-icon icon="x" font-scale="1.2"></b-icon></b-button>
                                                                    </template>
                                                                </b-col>
                                                            </b-form-row>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <b-form-input v-model="detailedItem.data[index].value" size="sm" placeholder=""></b-form-input>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-if="item.reference != 0">
                                                <tsoft-select-of-properties
                                                    :reference_id="item.reference"
                                                    :needGroups="item.reference == 5 ? true : false"
                                                    :needNullElement="true"
                                                    :selected="item.value"
                                                    :index="index"
                                                    @set="setReferenceValue"
                                                ></tsoft-select-of-properties>
                                            </template>
            
                                            <template v-if="index == 0 && filteredDocs.length > 0">
                                                <div class="mt-2 font-weight-bold">Выберите договор:</div>
                                                <div 
                                                    v-for="doc in filteredDocs" 
                                                    @click="changeSelectedDoc(doc)"
                                                    :key="doc.id"
                                                    class="docSelectLinks"
                                                >
                                                    {{ doc.name }} ({{ doc.date_of_document | formattedDate }})
                                                </div>
                                            </template>
                                        </template>    
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                            <!-- <caption>
                                <b-row class="align-items-center">
                                    <b-col>
                                        <b-form-checkbox v-model="checkedLoadDocument" name="check-button" switch class="mr-4">
                                            <span class="text-bold-size-13">Прикрепить документ</span>
                                        </b-form-checkbox>
                                    </b-col>
                                </b-row>
                            </caption> -->
                        </b-table-simple>
                    </b-card>
                </div>

                <div class="interface_v2" v-show="detailsInfoTab === 'quotation'">
                    <b-card>
                        <b-container fluid>
                            <OrderServiceGeneralQuotationInfo
                                v-if="generalQuotationInfoPayload"
                                :quotation="generalQuotationInfoPayload"
                                :show-answers="true"
                            />
                            <div v-else-if="isLoadingGeneralQuotationInfo" class="text-center py-4">
                                <b-spinner small class="mr-2"></b-spinner>
                                Загрузка данных котировки...
                            </div>
                            <div v-else class="text-muted py-3">
                                Информация по котировке отсутствует.
                            </div>
                        </b-container>
                    </b-card>
                </div>
            </div>
        </template>
        <div class="mt-3">
            <b-row class="align-items-center mb-3">
                <b-col sm="12">
                    <b-form-checkbox v-model="checkedLoadDocument" name="check-button" switch class="mr-4">
                        <span class="text-bold-size-13">Прикрепить документ</span>
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <div class="document_upload" v-if="checkedLoadDocument">
                <tsoft-create-documents
                    :needMultiUploadDocuments="true"
                    :orderServiceId="detailedItem.id"
                    :orderId="detailedItem.order_id"
                    :companyId="detailedItem.company_id"
                    :needUploadButton="true"
                    @documentLoaded="onCloseSidePanelLoadingDocument"
                />
            </div>

            <div class="document_view_order" v-if="(detailedItem.documents && detailedItem.documents.length > 0) || updateDocumentListCounter > 0">
                <h5>Документы по услуге</h5>
                <tsoft-show-edit-documents
                    :orderId="detailedItem.order_id"
                    :orderServiceId="detailedItem.id"
                    :companyId="detailedItem.company_id"
                    :requestDocuments="requestDocuments"
                    :updateDocumentList.sync="updateDocumentListCounter"
                    @onFileOperationCompleted="onDocumentListChanges"
                />
            </div>

            <!-- Блок инструкций по статусам для заказов типа 1 (кроме логистики) -->
            <div v-if="!isAgent && detailedItem.reference_service_id != 23 && detailedItem.order && detailedItem.order.reference_order_type_id == 1" class="mt-4">
                <div 
                    v-if="[359, 539, 540].includes(detailedItem.order.reference_status_id)"
                    class="mb-2"
                >
                    <div class="text-right mb-2">
                        <b-button 
                            variant="primary"
                            @click="changeOrderStatus(541)"
                            :disabled="isChangingOrderStatus"
                        >
                            Перевести в статус «Получение котировки»
                            <i class="fas fa-arrow-right ml-2"></i>
                        </b-button>
                    </div>
                    <div class="text-right lh12px">
                        <small>
                          <em>Если клиент готов получить предложение, <br />
                            переведите заявку в статус «Получение котировки», чтобы произвести расчет.
                          </em>
                        </small>
                    </div>                    
                </div>          
                <div 
                    v-if="detailedItem.order.reference_status_id == 541"
                    class="mb-2"
                >
                    <div class="text-right mb-2">
                        <b-button
                            v-if="!isAgent" 
                            variant="primary"
                            @click="changeOrderStatus(542)"
                            :disabled="isChangingOrderStatus"
                        >
                            Перевести в статус «Котировка получена»
                            <i class="fas fa-arrow-right ml-2"></i>
                        </b-button>
                    </div>
                    <div class="text-right lh12px">
                        <small>
                          <em>Заявка в статусе «Получение котировки».<br />
                            Если расчеты по всем услугам произведены, <br />
                            заказ можно будет перевести в статус «Котировка получена».
                          </em>
                        </small>
                    </div>
                </div>          
                <div 
                    v-if="detailedItem.order.reference_status_id == 542"
                    class="mb-2"
                >
                    <div class="text-right mb-2">
                        <b-button 
                            variant="primary"
                            @click="changeOrderStatus(543)"
                            :disabled="isChangingOrderStatus"
                            class="mr-2"
                        >
                            Перевести в статус «КП Направлено»
                            <i class="fas fa-arrow-right ml-2"></i>
                        </b-button>
                    </div>
                    <div class="text-right lh12px">
                        <small>
                          <em>Заявка в статусе «Котировка получена».<br />
                            Ожидается проставление ставок для клиента и перевод в статус «КП Направлено».
                          </em>
                        </small>
                    </div>
                </div>
            </div>

            <b-overlay
                :show="dataOverlay"
                spinner-variant="success"
                no-wrap
            ></b-overlay>
        </div>
    </div>
</template>

<script>
import eventBus from '@/eventBuses/eventBus.js';
import { mapGetters } from 'vuex';

import { 
    API_ORDERS_BY_SERVICES, 
    API_POST_ORDERS_SERVICES_MASS_SAVE, 
    API_POST_ORDERS_SERVICES_UPDATE_V2,
    API_PUT_ORDER_SERVICES, 
    API_ORDERS_SERVICE_PROPERTY,
    SERVICE_TO_DOCUMENT,
    API_ORDERS_SERVICE,
    API_ORDERS,
    API_ORDER_VALIDATE_STATUS_541,
    API_ORDER_VALIDATE_STATUS_542,
    API_POST_ORDER_SERVICES_GENERAL_QUOTATIONS_FIND,
} from '@/constants';
import { constantsAllReferenceProperties, defaultDataItems } from '@/mixins';
import { quotationValidationMixin } from '@/mixins/quotationValidationMixin';
import OrderServiceComments from '@components/orders/OrderServiceComments.vue';
import TemplateFCL from '@components/orders/orderServiceTemplate/v2/TemplateFCL.vue';
import TemplateRFCL from '@components/orders/orderServiceTemplate/v2/TemplateRFCL.vue';
import TemplateAIR from '@components/orders/orderServiceTemplate/v2/TemplateAIR.vue';
import TemplateFTL from '@components/orders/orderServiceTemplate/v2/TemplateFTL.vue';
import TemplateRUS from '@components/orders/orderServiceTemplate/v2/TemplateRUS.vue';
import OrderServiceDeliveryQuotation from '@/components/orders/orderServiceQuotation/OrderServiceDeliveryQuotation.vue';
import OrderServiceGeneralQuotation from '@/components/orders/orderServiceQuotation/OrderServiceGeneralQuotation.vue';
import OrderServiceDeliveryQuotationInfo from '@/components/orders/orderServiceQuotation/OrderServiceDeliveryQuotationInfo.vue';
import OrderServiceGeneralQuotationInfo from '@/components/orders/orderServiceQuotation/OrderServiceGeneralQuotationInfo.vue';

export default {
    props: {
        order_id: { type: Number|String, required: true },
        reference_service_id: { type: Number|String, required: true },
    },
    mixins: [
        constantsAllReferenceProperties,
        defaultDataItems,
        quotationValidationMixin
    ],
    components: {
        OrderServiceComments,
        TemplateFCL,
        TemplateRFCL,
        TemplateAIR,
        TemplateFTL,
        TemplateRUS,
        OrderServiceDeliveryQuotation,
        OrderServiceGeneralQuotation,
        OrderServiceDeliveryQuotationInfo,
        OrderServiceGeneralQuotationInfo
    },
    data() {
        return {
            dataOverlay: true,
            isRequestValid: false,
            detailedItem: {
                id: '',
                order_id: '',
                company_id: '',
                service_name: '',
                data: {},
                quotation: {},
                users: [],
                documents: [],
                company_documents: [],
            },
            beforeStartSave: false,
            editMode: false,
            saveMode: false,
            isDataRefreshing: false,
            actionReferenceProperties: {
                253: {
                    control_ids: [253],    // See reference_properties table
                    count: 0,
                    type: 'group',
                    create_doubles: true,
                    default_name: 'Номера транспортного средства: АВТО, ЖД, МОРЕ - номер тр.ср.; для АВИА - номер накладной',
                    readonly: false,
                    increment_id: 252       // Счетчик полей в БД
                },
                257: {
                    control_ids: [257, 258, 259],    // See reference_properties table
                    count: 0,
                    type: 'group',
                    create_doubles: true,
                    default_name: 'Номер ДТ',
                    readonly: false,
                    increment_id: 256       // Счетчик полей в БД
                },
                274: {
                    control_ids: [274],     // See reference_properties table
                    count: 0,
                    type: 'group',
                    create_doubles: true,
                    default_name: 'Номер транспортной накладной (BL, CMR, MAWB)',
                    readonly: false,
                    increment_id: 273       // Счетчик полей в БД
                },
                276: {
                    control_ids: [276],        // See reference_properties table
                    count: 0,
                    type: 'group',
                    create_doubles: true,
                    default_name: 'Номера транспортного средства: АВТО, ЖД, МОРЕ - номер тр.ср.; для АВИА - номер накладной',
                    readonly: false,
                    increment_id: 275       // Счетчик полей в БД
                },
                252: {
                    type: 'inline'
                },
                256: {
                    type: 'inline'
                },
                273: {
                    type: 'inline'
                },
                275: {
                    type: 'inline'
                },
            },
            checkedLoadDocument: false,
            requestDocuments: true,
            updateDocumentListCounter: 0,
            filteredDocs: [],
            currentOrderServiceComponent: '',
            isChangeManager: false,
            tempUserIds: null,
            deliveryQuotationDate: '',
            isSavingOrderService: false,
            isChangingOrderStatus: false,
            detailsInfoTab: 'obshaya',
            generalQuotationInfo: null,
            isLoadingGeneralQuotationInfo: false
        }
    },
    computed: {
        ...mapGetters("auth", ["currentUser"]),

        isAgent() {
            return this.currentUser.role.includes('agent');
        },

        hasQuotationInfo() {
            return this.hasDeliveryQuotationInfo || this.shouldLoadGeneralQuotationInfo;
        },

        hasDeliveryQuotationInfo() {
            return !!(this.detailedItem && this.detailedItem.quotation && this.detailedItem.quotation.data);
        },

        deliveryQuotationForInfo() {
            if (!this.hasDeliveryQuotationInfo) {
                return null;
            }

            // Убеждаемся, что data существует и является объектом
            const quotation = this.detailedItem.quotation;
            if (!quotation || !quotation.data || typeof quotation.data !== 'object') {
                return null;
            }

            return {
                ...quotation,
                data: {
                    ...quotation.data,
                    // Убеждаемся, что dimensions существует
                    dimensions: quotation.data.dimensions || {}
                },
                order_id: this.detailedItem.order_id,
                order_service_id: this.detailedItem.id,
                order_reference_status_id: this.detailedItem.order ? this.detailedItem.order.reference_status_id : null
            };
        },

        generalQuotationInfoPayload() {
            if (!this.generalQuotationInfo || !this.generalQuotationInfo.data) {
                return null;
            }

            return {
                ...this.generalQuotationInfo,
                order_id: this.detailedItem.order_id,
                order_service_id: this.detailedItem.id,
                order_reference_status_id: this.detailedItem.order ? this.detailedItem.order.reference_status_id : null
            };
        },

        shouldLoadGeneralQuotationInfo() {
            // Загружаем общую котировку, если это не доставка (reference_service_id != 23)
            // и есть данные о сервисе и заказе
            return !!(
                this.detailedItem &&
                this.detailedItem.reference_service_id != 23 &&
                this.detailedItem.order
            );
        }
    },    
    created() {
        this.index();
    },
    methods: {
        async handleOrderUpdated(data) {
            // Обновляем данные сервиса заказа и ожидаем завершения
            await this.index();
            // Эмитим событие вверх для обновления данных заказа после загрузки
            this.$emit('orderUpdated', data);
        },
        addNewFieldByField(index) {
            this.dataOverlay = true;

            let nowPropertyId = this.detailedItem.data[index].reference_service_property_id;

            const addElement = {
                order_service_id: this.detailedItem.data[index].order_service_id,
                reference: this.detailedItem.data[index].reference,
                reference_service_property_id: nowPropertyId,
                value: 'б/н'
            };
            api.call('post', API_ORDERS_SERVICE_PROPERTY, addElement).then(({data}) => {
                this.actionReferenceProperties[nowPropertyId].count++;
                this.detailedItem.data = this.detailedItem.data.concat(data.reverse());
                this.groupFields();
                this.dataOverlay = false;
                this.makeToast('success', 'Успешно сохранено');
            })
        },
        deleteField(index) {
            let id = this.detailedItem.data[index].id;
            let nowPropertyId = this.detailedItem.data[index].reference_service_property_id;

            this.$swal({
                title: 'Подтвердите удаление',
                icon: 'question',
                showCancelButton: true,
                cancelButtonText: 'Нет',
                confirmButtonText: 'Да',
            }).then((result) => {
                if(result.isConfirmed){
                    this.dataOverlay = true;
                    api.call('delete', `${API_ORDERS_SERVICE_PROPERTY}/${id}`).then(({data}) => {
                        this.actionReferenceProperties[nowPropertyId].count--;
                        this.detailedItem.data.splice(index, this.actionReferenceProperties[nowPropertyId].control_ids.length);
                        this.groupFields();
                    }).finally(() => {
                        this.dataOverlay = false;
                        this.makeToast('danger', 'Данные удалены');
                    })
                }
            })
        },
        async index() {
            this.isDataRefreshing = true
            this.dataOverlay = true;
            const { data } = await api.call('get', `/api/orders/${this.order_id}/services/${this.reference_service_id}`);
            this.detailedItem = data;
            this.dataOverlay = false;
            this.isDataRefreshing = false;

            this.selectInterfaceTwoVersion();

            if (this.detailedItem.interface_version === 1) {
                this.groupFields();
            }

            this.setDocumentRelation();

            this.$emit('setServiceInfo', data.id, data.data);
            // this.setDataFromQuotation();
            
            await this.loadGeneralQuotationInfo();
        },
        setDocumentRelation() {
            let service_id = this.reference_service_id;
            if (SERVICE_TO_DOCUMENT[service_id] && this.detailedItem.company_documents.length > 0) {
                let find_document_by_property_id = SERVICE_TO_DOCUMENT[service_id];

                this.filteredDocs = this.detailedItem.company_documents.filter((doc) => doc.reference_document_type_id == find_document_by_property_id)

                this.detailedItem.company_documents.forEach((document, index) => {
                    // @TODO: ПЕРЕДЕЛАТЬ, ОРИЕНТИРОВАТЬСЯ НА ИНДЕКСЫ - ПЛОХО
                    if ((typeof find_document_by_property_id === 'string' && find_document_by_property_id.indexOf(document.reference_document_type_id, 0) != -1)
                        || find_document_by_property_id == document.reference_document_type_id) {
                        if (!this.detailedItem.data || !this.detailedItem.data[0] || !this.detailedItem.data[1]) {
                            this.detailedItem.data = { 
                                "0": {
                                    value: '' 
                                },
                                "1": {
                                    value: '' 
                                },
                            };
                        }
                        
                        this.detailedItem.data[0].value = !this.detailedItem.data[0].value ? document.name : this.detailedItem.data[0].value;
                        this.detailedItem.data[1].value = !this.detailedItem.data[1].value ? document.date_of_document : this.detailedItem.data[1].value;
                    }
                })
            }
        },
        async loadGeneralQuotationInfo() {
            if (!this.shouldLoadGeneralQuotationInfo) {
                this.generalQuotationInfo = null;
                return;
            }

            this.isLoadingGeneralQuotationInfo = true;

            try {
                const params = {
                    order_id: this.detailedItem.order_id,
                    order_service_id: this.detailedItem.id
                };

                const { data } = await api.call('post', API_POST_ORDER_SERVICES_GENERAL_QUOTATIONS_FIND, params);

                if (data.success && data.quotation) {
                    this.generalQuotationInfo = data.quotation;
                } else {
                    this.generalQuotationInfo = null;
                }
            } catch (error) {
                console.error('Ошибка загрузки информации по котировке услуги:', error);
                this.generalQuotationInfo = null;
            } finally {
                this.isLoadingGeneralQuotationInfo = false;
            }
        },

        setDataFromQuotation(force = false) {
            this.$swal.fire({
                title: 'Вы уверены?',
                text: 'Вы уверены в переносе данных из котировки? Могут быть затёрты некоторые свойства в поставке, которые вы уже заполнили.',
                icon: 'warning',
                confirmButtonColor: "#0D6247",
                cancelButtonColor: "#676868",                
                showCancelButton: true,
                confirmButtonText: 'Да, перенести',
                cancelButtonText: 'Нет, отмена'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.applyQuotationData(force);
                }
            });
        },

        applyQuotationData(force = false) {
            if (force || (this.detailedItem.quotation && this.detailedItem.quotation.data)) {
                // this.detailedItem.data = {};
                const quotation = this.detailedItem.quotation.data;
                // console.log("quotation", quotation);
                // console.log("detailedItem", this.detailedItem);

                // Если `this.detailedItem.data` не существует
                if (!this.detailedItem.data) {
                    this.$set(this.detailedItem, 'data', {});
                }

                if (quotation.cargo_code) {
                    this.$set(this.detailedItem.data, 'name_of_cargo', `${quotation.cargo_name}, ${quotation.cargo_code}`);
                } else {
                    this.$set(this.detailedItem.data, 'name_of_cargo', quotation.cargo_name);
                }

                this.$set(this.detailedItem.data, 'weight', quotation.gross_weight);
                this.$set(this.detailedItem.data, 'volume', quotation.dimensions.volume);
                this.$set(this.detailedItem.data, 'usloviya_postavki_id', quotation.set_delivery_conditions_ids[0]);

                if (this.detailedItem.data.number_of_places) {
                    this.$set(this.detailedItem.data, 'number_of_places', quotation.number_of_places);
                }
                if (this.detailedItem.data.naselenniy_punkt) {
                    this.$set(this.detailedItem.data, 'naselenniy_punkt', quotation.loading_places[0].address);
                }
                if (this.detailedItem.data.address_of_unloading) {
                    let address = quotation.unloading_places[0].address
                    if (quotation.unloading_places[0].city) {
                        address = quotation.unloading_places[0].city + ', ' + address;
                    }

                    this.$set(this.detailedItem.data, 'address_of_unloading', address);
                }
                if (this.detailedItem.data.address_of_unloading_town) {
                    this.$set(this.detailedItem.data, 'address_of_unloading_town', quotation.unloading_places[0].city);
                }
                if (this.detailedItem.data.address_of_unloading_street) {
                    this.$set(this.detailedItem.data, 'address_of_unloading_street', quotation.unloading_places[0].street);
                }

                if (this.detailedItem.data.number_of_container) {
                    if (quotation.transport_types_and_kinds[0].quantity) {
                        this.$set(this.detailedItem.data, 'number_of_container', quotation.transport_types_and_kinds[0].quantity);
                    }
                }

                this.detailedItem.data = JSON.parse(JSON.stringify(this.detailedItem.data));
                // OTHER QUOTATION RULES IF WE FIND THEM!
            }
        },
        dataExchange() {
            console.log("Копируем данные из котировки!");
            this.setDataFromQuotation(true);
        },
        changeSelectedDoc(doc) {
            this.detailedItem.data[0].value = doc.name;
            this.detailedItem.data[1].value = doc.date_of_document;
        },
        setReferenceValue(value, reference_id, index) {
            this.detailedItem.data[index].value = value
        },
        /// INTERFACE 2
        setOrderServiceType(value) {
            this.beforeStartSave = true;
            this.detailedItem.reference_property_type_id = value;
        },
        saveOrderServiceType() {
            if (!this.isRequestValid) {
                this.$bvToast.toast('Форма котировки поставки не до конца заполнена. Завершите заполнение формы котировки.', {
                    title: 'Невозможно начать ведение',
                    variant: 'info',
                    solid: true,
                });

                return false;
            }
            
            this.isSavingOrderService = true;
            
            api.call('put', `${API_ORDERS_BY_SERVICES}/${this.detailedItem.id}`, {
                reference_property_type_id: this.detailedItem.reference_property_type_id
            }).then((response) => {
                this.index();
                this.beforeStartSave = false;
            }).finally(() => {
                this.isSavingOrderService = false;
            })
        },
        saveOrderService() {
            this.saveOrderServiceType();
        },
        selectInterfaceTwoVersion() {
            if (this.detailedItem.interface_version == 2 && this.detailedItem.reference_property_type_id) {
                switch (this.detailedItem.reference_property_type_id) {
                    // FCL/LCL – мультимодальная
                    case 565:
                        this.currentOrderServiceComponent = TemplateFCL;
                        break;
                    // RFCL/RLCL – прямое ЖД
                    case 566:
                        this.currentOrderServiceComponent = TemplateRFCL;
                        break;
                    // FTL/LTL  - международная автоперевозка
                    case 567:
                        this.currentOrderServiceComponent = TemplateFTL;
                        break;
                    // AIR – авиа
                    case 568:
                        this.currentOrderServiceComponent = TemplateAIR;
                        break;
                    // RUS – внутрироссийская перевозка
                    case 569:
                        this.currentOrderServiceComponent = TemplateRUS;
                        break;
                }
            }
        },
        /// END: INTERFACE 2
        getPropertyNameByValue(value) {
            let result = 'Нет данных'
            if (value && this.referencePropertiesList[value]) {
                result = this.referencePropertiesList[value]['text']
            }
            return result
        },
		getAllManagerNames() {
			let name = "Не назначен";
			if (this.detailedItem.users.length > 0) {
				name = this.detailedItem.users.map(user => user.name).join(', ');
			}
			return name;
		},		
        getManagerName() {
            let name = "Не назначен"
            if (this.detailedItem.users.length > 0) {
                name = this.detailedItem.users[0].name
            }
            return name
        },
        getStatusName() {
            let name = "Не известен"
            if (this.detailedItem.status && this.detailedItem.status.name) {
                name = this.detailedItem.status.name
            }
            return name
        },
        groupFields() {
            const sortServicePropertiesByOrderNumber = (a, b) => {
                return (a['reference_service_property_ordering_number'] > b['reference_service_property_ordering_number'] && 1) ||
                (a['reference_service_property_ordering_number'] === b['reference_service_property_ordering_number'] ? 0 : -1)
            }

            const groupServicePropertiesId = (a, b) => {
                return (a['reference_service_property_id'] > b['reference_service_property_id'] && 1) ||
                    (a['reference_service_property_id'] === b['reference_service_property_id'] ? 0 : -1)
            }

            const groupServicePropertiesByGroupId = (a, b) => {
                a['group_id'] = a['group_id'] ? a['group_id'] : 0
                b['group_id'] = b['group_id'] ? b['group_id'] : 0

                return (a['group_id'] > b['group_id'] && 1) ||
                    (a['group_id'] === b['group_id'] ? 0 : -1)
            }

            this.detailedItem.data = this.detailedItem.data.sort(groupServicePropertiesId)
            this.detailedItem.data = this.detailedItem.data.sort(groupServicePropertiesByGroupId)
            this.detailedItem.data = this.detailedItem.data.sort(sortServicePropertiesByOrderNumber)

            this.actionReferenceProperties[253].count = 0
            this.actionReferenceProperties[257].count = 0
            this.actionReferenceProperties[274].count = 0
            this.actionReferenceProperties[276].count = 0
            this.detailedItem.data.forEach((item, index) => {
                let nowPropertyId = item.reference_service_property_id
                if (this.actionReferenceProperties[nowPropertyId]) {
                    // If we have counter - increase it
                    if (this.actionReferenceProperties[nowPropertyId].count >= 0) {
                        item.reference_service_property_name = this.actionReferenceProperties[nowPropertyId].default_name
                        this.actionReferenceProperties[nowPropertyId].count++
                        item.reference_service_property_name += ' ' + this.actionReferenceProperties[nowPropertyId].count
                    }
                }
            })
            // update increments ids counts
            this.detailedItem.data.forEach((item, index) => {
                let nowPropertyId = item.reference_service_property_id
                switch(nowPropertyId) {
                    case this.actionReferenceProperties[253].increment_id:
                        item.value = this.actionReferenceProperties[253].count
                        break
                    case this.actionReferenceProperties[257].increment_id:
                        item.value = this.actionReferenceProperties[257].count
                        break
                    case this.actionReferenceProperties[274].increment_id:
                        item.value = this.actionReferenceProperties[274].count
                        break
                    case this.actionReferenceProperties[276].increment_id:
                        item.value = this.actionReferenceProperties[276].count
                        break
                }
            })
        },
        excludePropertyFromTextFiltering(property_id) {
            let excludeArray = [253, 276];
            return excludeArray.includes(property_id) ? true : false;
        },
        save() {
            this.dataOverlay = true;

            if (this.detailedItem.interface_version == 2) {
                this.saveMode = true;
            } else {
                api.call('post', API_POST_ORDERS_SERVICES_MASS_SAVE, { order_service_properties: this.detailedItem.data, order_id: this.detailedItem.order_id }).then(({data}) => {
                    this.editMode = false;
                    this.dataOverlay = false;
                    this.$emit('setServiceInfo', this.detailedItem.id, this.detailedItem.data)
                    this.makeToast('success', 'Успешно сохранено');
                })
            }
        },
        chooseActiveButton(onShowId) {
            return this.detailedItem.reference_property_status_id == onShowId ? true : false
        },
        changeStatus(reference_property_status_id) {
            this.dataOverlay = true;
            this.detailedItem.reference_property_status_id = reference_property_status_id;

            api.call('put', `${API_PUT_ORDER_SERVICES}/${this.detailedItem.id}`, {
                reference_property_status_id: this.detailedItem.reference_property_status_id
            }).then(({data}) => {
                this.index()
            }).finally(() => (
                this.dataOverlay = false
            ))
        },
        onCloseSidePanelLoadingDocument(value) {
            this.updateDocumentListCounter++;
            this.onDocumentListChanges();
        },
        onDocumentListChanges() {
            if (this.detailedItem.interface_version === 2) {
                this.index();
            }
        },
        updateData(data) {
            api.call('post', `${API_POST_ORDERS_SERVICES_UPDATE_V2}/${this.detailedItem.id}`, { data: data }).then(({response}) => {
                this.detailedItem.data = data;
                this.editMode = false;
                this.saveMode = false;
                this.dataOverlay = false;
                this.makeToast('success', 'Успешно сохранено');
                eventBus.$emit('update-one-logistic-order', this.detailedItem.id);
            })
        },
        nameOfType() {
            if (this.detailedItem.interface_version != 1) {
                if (this.detailedItem.reference_property_type && this.detailedItem.reference_property_type.name) {
                    return `. ${this.detailedItem.reference_property_type.name}`;
                }
            } 

            return '';
        },
        getSelectedUserIds() {
            if (this.detailedItem.users && this.detailedItem.users.length) {
                return this.detailedItem.users.map(user => user.id);
            }

            return [];
        },
        setUserIds(value) {
            this.tempUserIds = value;
        },
        cancelChangeManager() {
            this.tempUserIds = null;
            this.isChangeManager = false;
        },
        async saveChangeManager() {
            await this.setNewManagers();
            this.cancelChangeManager();
        },
        async setNewManagers() {
            if (this.detailedItem.users.length) {
				let detailedUserIds = this.detailedItem.users.map(user => user.id);

				let areArraysSimilar = this.tempUserIds.length === detailedUserIds.length &&
    			this.tempUserIds.every(id => detailedUserIds.includes(id));

	            if (areArraysSimilar) {
					return
				}
            }

            // null не отправляется, если пользователь не выбран
            await api.call('post', API_ORDERS_SERVICE + `/${this.detailedItem.id}/users`, {
                'selected_user': this.tempUserIds
            })
            .then(({data}) => {
                this.index();
            })
            .catch(e => console.log(e))
        },
        setOrderServiceTypeFromQuotation(value) {
            if (this.detailedItem.reference_property_type_id) {
                return;
            }

            let variants = {
                992: 567,   // FTL
                993: 567,   // LTL
                994: 565,   // FCL
                995: 565,   // LCL
                996: 566,   // RFCL
                997: 566,   // RLCL
                998: 568,   // AIR
                // 569 - RUS
            }
            
            const variant = variants[value] ? variants[value] : 569;

            this.setOrderServiceType(variant);
        },
        setValuesFromQuotation(quotation) {
            this.deliveryQuotationDate = ` (версия от ${quotation.updated_at})`;
            this.setOrderServiceTypeFromQuotation(quotation.data.transport_types_id);
        },
        isRequestFormValid(isValid) {
            this.isRequestValid = isValid;
        },
        onSaved() {
            this.index();
        },
        onChangeOrderToQuotationSent(orderId, newStatus) {
            // Вызываем метод для изменения статуса заказа
            this.changeOrderStatus(newStatus);
        },
        onMakeOrderSupply(orderId) {
            // Передаем событие дальше в родительский компонент для перевода заказа в поставку
            this.$emit('makeOrderSupply', orderId);
        },
        
        // Методы для обработки событий от компонента котирования
        changeOrderToQuotationSent(orderId, newStatus) {
            // Вызываем метод для изменения статуса заказа
            this.changeOrderStatus(newStatus);
        },

        handleOrderUpdated(data) {
            // Обновляем данные компонента при изменении заказа
            this.index();
            
            // Передаем событие дальше в родительский компонент
            this.$emit('orderUpdated', data);
        },
        
        // Метод для изменения статуса заказа
        async changeOrderStatus(newStatusId) {
            try {
                this.isChangingOrderStatus = true;
                
                // Определяем название статуса для уведомления
                const statusNames = {
                    541: 'Получение котировки',
                    542: 'Котировка получена',
                    543: 'КП Направлено',
                    362: 'Закрыт'
                };
                
                const statusName = statusNames[newStatusId] || `Статус ${newStatusId}`;
                
                // Для статуса 541 выполняем валидацию
                if (newStatusId === 541) {
                    try {
                        const response = await api.call('post', API_ORDER_VALIDATE_STATUS_541, {
                            order_id: this.detailedItem.order_id
                        });
                        
                        // Проверяем успешность валидации
                        if (!response.data.success) {
                            // Показываем ошибки валидации
                            this.handleValidationErrors(response.data);
                            return;
                        }
                    } catch (validationError) {
                        console.error('Ошибка при валидации статуса:', validationError);
                        this.$bvToast.toast('Произошла ошибка при проверке валидации', {
                            title: 'Ошибка валидации',
                            variant: 'danger',
                            solid: true,
                            autoHideDelay: 5000
                        });
                        return;
                    }
                }
                
                // Для статуса 542 выполняем валидацию
                if (newStatusId === 542) {
                    try {
                        const response = await api.call('post', API_ORDER_VALIDATE_STATUS_542, {
                            order_id: this.detailedItem.order_id
                        });
                        
                        // Проверяем успешность валидации
                        if (!response.data.success) {
                            // Показываем ошибки валидации
                            this.handleValidationErrors(response.data);
                            return;
                        }
                    } catch (validationError) {
                        console.error('Ошибка при валидации статуса:', validationError);
                        this.$bvToast.toast('Произошла ошибка при проверке валидации', {
                            title: 'Ошибка валидации',
                            variant: 'danger',
                            solid: true,
                            autoHideDelay: 5000
                        });
                        return;
                    }
                }
                
                // Показываем подтверждение для критических действий
                if (newStatusId === 362) {
                    const result = await this.$swal({
                        title: 'Подтвердите действие',
                        text: 'Вы уверены, что хотите закрыть заявку? Это действие нельзя отменить.',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Да, закрыть',
                        cancelButtonText: 'Отмена',
                        confirmButtonColor: '#dc3545'
                    });
                    
                    if (!result.isConfirmed) {
                        return;
                    }
                }
                
                // Отправляем запрос на изменение статуса
                await api.call('put', `${API_ORDERS}/${this.detailedItem.order_id}`, {
                    reference_status_id: newStatusId
                });

                // Показываем уведомление об успехе
                this.$bvToast.toast(`Заказ успешно переведен в статус «${statusName}»`, {
                    title: 'Статус изменен',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 3000
                });
                
                // Обновляем данные компонента
                await this.index();
                
                // Передаем событие в родительский компонент
                this.$emit('orderUpdated', { order_id: this.detailedItem.order_id, new_status_id: newStatusId });
                
            } catch (error) {
                console.error('Ошибка при изменении статуса заказа:', error);
                
                // Показываем уведомление об ошибке
                this.$bvToast.toast('Произошла ошибка при изменении статуса заказа', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    autoHideDelay: 5000
                });
            } finally {
                this.isChangingOrderStatus = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .bdr-tabs {
        margin-bottom: 25px;
    }

    .bdr-tabs .card-body {
        padding: 1.25rem 0px;
    }

    .order-service-menu {
        font-weight: bold;
        border-bottom: 2px solid #CCC;
        cursor: pointer;
        padding-bottom: 6px;
        padding-left: 4px;
        padding-right: 4px;
        display: inline-block;
        user-select: none;
        transition: all 0.2s ease;

        &:hover {
            color: #EA7B27;
        }

        &__active {
            color: #EA7B27;
            border-bottom: 2px solid #EA7B27;
        }
    }
</style>
